import React from 'react';
import Reflux from 'reflux';
import history from '../history';

class NotFoundPage extends Reflux.Component {
    goToHome = () => {
        history.push('/');
    }
    render () {
        return (<div>
          <div className='back-notfound'>
            <div className='center-content-notfound'>
              <h2>4<span><img src='/images/icons/globe-white.svg' /></span>4</h2>
              <p>Parece que ésta página no existe!</p>
              <a className='newButton' onClick={this.goToHome}>Volver a Top5</a>
            </div>
          </div>
        </div>
        );
    };
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.js